import usePaginatedLogList from "../../../hooks/usePaginatedLogList";
import LogListError from "../../../components/LogListError";
import React, { useEffect, useState } from "react";
import { Button, DatePicker, Select, Table } from "antd";
import { useNavigate } from "react-router-dom";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL, dailyconsumptionPdfUrl } from "../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import VoyageDetails from "../../../components/VoyageDetails";
import { formatDate } from "../../../utils/dateFormatter";
import useVoyageList from "../../../hooks/useVoyageList";
import dayjs from "dayjs";
import { dateRanges } from "../../../Data/data";
import { DOWNLOADPDF } from "../../../utils/downloadPdf";

const { RangePicker } = DatePicker;

const DailyConsumptionList = () => {
  const navigate = useNavigate();
  const { voyageList } = useVoyageList();
  const { data: filteredData, loading: page_loader, load: loadRecords, pagination, error, retry } =
    usePaginatedLogList(ApiURL.list_daily_consumption_log, "logs");
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const [dates, setDates] = useState([dayjs().subtract(2, "day"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD")) || [];

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (voyage_ids) {
      DAILY_CONSUMPTION_LIST_API(voyage_ids);
    }
  }, [voyage_ids]);

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find(
        (voyage) => voyage.voyage_status == true
      );
      set_voyage_status(runningVoyage?.voyage_status);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
      }
    }
  }, [voyageList]);

  const DAILY_CONSUMPTION_LIST_API = (voyage_id) => {
    if (!voyage_id) return;
    return loadRecords({ voyage_id });
  };

  const DELETE_DAILY_CONSUMPTION_RECORD = (id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", id);
    post(ApiURL.delete_daily_task_report_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast(
          "Success!!",
          "Daily consumption Details Successfully deleted."
        );
        DAILY_CONSUMPTION_LIST_API(voyage_ids);
      } else {
        ErrorToast("Error", "Sorry Daily consumption details not deleted ");
      }
    });
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "daily_consumption_log_id",
      align: "center",
      key: "daily_consumption_log_id",
      sorter: (a, b) => a.daily_consumption_log_id - b.daily_consumption_log_id,
    },
    {
      title: "Type of event",
      dataIndex: "type_of_event",
      align: "center",
      key: "type_of_event",
    },
    {
      title: "Stay",
      dataIndex: "stay",
      align: "center",
      key: "stay",
      render: (text, record) => (record?.stay === "SS" ? "SP" : "stay"),
    },

    {
      title: "RPM",
      dataIndex: "rpm",
      align: "center",
      key: "rpm",
    },
    {
      title: "Speed",
      dataIndex: "speed",
      align: "center",
      key: "speed",
    },
    {
      title: "Slip",
      dataIndex: "slip",
      align: "center",
      key: "slip",
    },
    {
      title: "Engine Distance",
      dataIndex: "engine_distance",
      align: "center",
      key: "engine_distance",
    },
    {
      title: "Date",
      dataIndex: "log_date",
      align: "center",
      key: "log_date",
      render: (text, record) => formatDate(record?.log_date),
    },
    {
      title: "Time",
      dataIndex: "log_time",
      align: "center",
      key: "log_time",
      width: 100,
      render: (text) => text || "-",
    },
  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={true}
        disabled={!voyage_status}
        buttonProps={{
          text: "Add Logs",
          className: "save_btn",
          onClick: () => navigate("/add-daily-consumption"),
          onPress: () => navigate("/audit-trail-consumption"),
        }}
      />
      <div className="row">
        <div
          className="col-3"
          style={{ marginBottom: "13px", marginLeft: "15px" }}
        >
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find(
                (voyage) => voyage.id === value
              );
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              DAILY_CONSUMPTION_LIST_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color:
                        voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3"></div>
        <div
          className="col-6"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() =>
                DOWNLOADPDF(
                  dailyconsumptionPdfUrl,
                  voyage_ids,
                  startDate,
                  endDate
                )
              }
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>

      <LogListError error={error} retry={retry} />
      <Table
        bordered
        loading={page_loader}
        columns={columns}
        dataSource={filteredData}
        pagination={pagination}
        rowKey="daily_consumption_log_id"
        className="custom-table"
      />
    </>
  );
};

export default DailyConsumptionList;
